/* eslint-disable @typescript-eslint/no-explicit-any */
import { CarType } from '@apps/containers/CarListing';

import { CarLaunchMonthNavBarItem } from '../CarLaunchMonthNavBarItem/settings';

import { CarLaunchMonthSectionType } from './props';

export const createNewLaunchSectionData = ({
  yearMonthObject,
  newLaunchCars,
}: {
  yearMonthObject: any;
  newLaunchCars: CarType[];
}): CarLaunchMonthSectionType[] => {
  const monthArray: CarLaunchMonthSectionType[] = Object.entries(
    yearMonthObject
  ).map(([monthYear, title], index) => {
    const key =
      monthYear === 'coming_soon'
        ? 'coming_soon'
        : (`month_${index}` as CarLaunchMonthNavBarItem);
    const cars =
      newLaunchCars?.filter((car: any) => car.year_month === monthYear) ?? [];
    return { key, title: title as string, data: cars };
  });

  return monthArray;
};
